import React, { useEffect } from "react";
import {
    Button,
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
    Typography,
} from "@material-tailwind/react";
import { FormProvider, useForm } from "react-hook-form";
import { fetcherFull } from "utils/api";
import RHFInput from "../form/rhf-input";
import { toast } from "react-toastify";

export default function ConfirmReportDialog(props) {
    const methods = useForm({
        mode: "onChange",
        defaultValues: { user_comment: "" },
    });
    const { reset } = methods;

    // Reset once per open transition so comments cannot bleed between
    // reported answers. reportedAnswer is not a dep: callers swap it
    // while the dialog is closed, so the open transition already covers
    // every change.
    useEffect(() => {
        if (props.showDialog) {
            reset({ user_comment: "" });
        }
    }, [props.showDialog, reset]);

    const handleClose = () => {
        props.setShowConfirmReportDialog(!props.showDialog);
        if (!props.showCustomResultsDialog) {
            props.setShowCustomResultsDialog(true);
        }
    };

    const reportSubmit = async (values) => {
        const response = await fetcherFull(
            `/v2/response/question/${props.question.nanoid}/answer/${props.reportedAnswer}/abuse`,
            "POST",
            { user_comment: values.user_comment },
        );
        if (response && response?.status === "reported") {
            toast.success("Answer Reported");
        } else {
            toast.error("Error Reporting Answer");
        }
        props.setShowConfirmReportDialog(false);
        handleClose();
    };

    return (
        <>
            <Dialog
                open={props.showDialog}
                handler={handleClose}
                className="dialog"
            >
                <FormProvider {...methods}>
                    <form
                        onSubmit={(e) => {
                            // Portaled dialog forms keep their React-tree
                            // position, so a submit here bubbles into any
                            // host form (the respondent form) and
                            // double-submits. Stop it at the source.
                            e.stopPropagation();
                            return methods.handleSubmit(reportSubmit)(e);
                        }}
                    >
                        <DialogHeader className="dialog__header">
                            Report an Answer
                        </DialogHeader>
                        <DialogBody className="dialog__body">
                            <Typography className="font-body my-2 text-center">
                                Would you like to add a comment as to why you
                                are reporting this answer? Please note that we
                                take all reports seriously and will check all
                                abuse. Any reports submitted will be treated in
                                the strictest confidence.
                            </Typography>
                            <RHFInput
                                className="p-2 font-body"
                                type="text"
                                variant="static"
                                size="md"
                                color="indigo"
                                name="user_comment"
                                placeholder="Enter your comment here!"
                            />
                        </DialogBody>
                        <DialogFooter className="dialog__footer">
                            <Button
                                type="submit"
                                className="btn btn--primary"
                                variant="filled"
                            >
                                Report
                            </Button>
                            <Button
                                type="button"
                                className="btn btn--secondary"
                                variant="filled"
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>
                        </DialogFooter>
                    </form>
                </FormProvider>
            </Dialog>
        </>
    );
}
